import gql from 'graphql-tag'
import { PaymentMethodPendingFieldsFragment } from './paymentMethodPending'

export const UPSERT_PAYMENT_METHOD_PENDING_MUTATION = gql`
  mutation UpsertPaymentMethodPending(
    $userId: Int!
    $plaidPublicToken: String!
    $paymentMethodPending: PaymentMethodPendingParams!
  ) {
    upsertPaymentMethodPending(
      userId: $userId
      plaidPublicToken: $plaidPublicToken
      paymentMethodPending: $paymentMethodPending
    ) {
      ...PaymentMethodPendingFields
    }
  }

  ${PaymentMethodPendingFieldsFragment}
`
